import React, { useState } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Logo } from "@/components/Logo";

const PLAN_INFO = {
  depart: { name: "Départ", price: "9,99 €", period: "mois", cadence: "mensuel", credits: "100 crédits/mois" },
  lancement: { name: "Lancement", price: "19,99 €", period: "3 mois", cadence: "trimestriel", credits: "400 crédits/mois" },
  acceleration: { name: "Accélération", price: "49,99 €", period: "an", cadence: "annuel", credits: "1500 crédits/mois" },
};

// Simulated Whop checkout (mock mode)
export default function MockPay() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [loading, setLoading] = useState(false);
  const plan = PLAN_INFO[params.get("plan")] ? params.get("plan") : "depart";
  const info = PLAN_INFO[plan];

  const pay = async () => {
    setLoading(true);
    try {
      await api.post("/mock/complete", { result_id: id });
      navigate(`/result/${id}?paying=1`);
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <div className="center-page">
      <div className="mb-12 w-full max-w-[480px]"><Logo onClick={() => navigate("/")} /></div>
      <main className="center-panel fade-in" data-testid="mock-checkout">
        <p className="eyebrow accent" data-testid="mock-payment-notice">MODE PAIEMENT SIMULÉ — DÉMO</p>
        <h1>Abonnement <em>{info.name}.</em></h1>
        <p className="muted text-sm">Abonnement {info.cadence} · {info.credits}</p>
        <div className="checkout-price" data-testid="checkout-price">{info.price}<span className="text-lg">/{info.period}</span></div>
        <div className="checkout-summary">
          <div><span>Formule {info.name}</span><span className="whitespace-nowrap">{info.price}/{info.period}</span></div>
          <div><span>Total aujourd'hui</span><span className="mono accent" data-testid="checkout-total">{info.price}</span></div>
        </div>
        <button onClick={pay} disabled={loading} data-testid="mock-pay-button" className="btn-primary w-full mt-8">{loading ? "Confirmation en cours..." : `S'abonner — ${info.price}/${info.period}`}{!loading && <span aria-hidden="true">→</span>}</button>
        <p className="muted text-xs mt-5 leading-relaxed">Stripe gérera le paiement réel (toutes cartes, Apple Pay, Google Pay) une fois les clés ajoutées.<br />Aucun montant n'est débité en mode démo.</p>
      </main>
    </div>
  );
}
